module.exports = __webpack_public_path__ + "media/entities/1502-d729afbf.png";